import type { UseSeoMetaInput } from '@unhead/vue'

type Opts = {
  title: string
  description: string
  type?: 'article' | 'website'
  image?: string
}

export function useCustomServerMeta({ title, description, type, image }: Opts) {
  const input: UseSeoMetaInput = {
    title,
    ogTitle: title,
    description,
    ogDescription: description,
    ogType: type || 'website',
    twitterTitle: title,
    twitterDescription: description,
  }
  // When a page supplies its own image (blog articles pass the Sanity mainImage),
  // override the app-level default og:image so social shares use the article art
  // instead of the generic /images/og-image.png. Omitted -> app default stands.
  if (image) {
    input.ogImage = image
    input.ogImageSecureUrl = image
    input.twitterImage = image
  }
  useSeoMeta(input)
}
